module.exports = __webpack_public_path__ + "images/macbook-es@2x-4a3a56.png";